export function Default() {
  return {
    updateDepartment: {
      isProcessing: false,
      error: false,
      success: false,
    },
  };
}
